import store from '@/state/store'
import Vue from 'vue'

export default [
  {
    path: '/NewAnket',
    name: 'NewAnket',
    meta: { authRequired: true },
    component: () => import('./views/Anket/NewAnket')
  },
  {
    path: '/:Sessionkey/:Email',
    name: 'default',
    component: () => import('./views/Anasayfa/Index'),
 
  },
  {
    path: '/',
    name: 'default',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/Anasayfa/Index'),
    beforeEnter(to,from,next){ 
      if(store.getters.["auth/isAuth"]){
        next()
      }else{
        window.location=Vue.prototype.$config.LOGIN_URL
      }
    }
  },
  {
    path: '/BirimSecimi',
    name: 'BirimSecimi',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/FormComponet/BirimSecimi'),
  },
  {
    path: '/StrHesapKodlari',
    name: 'StrHesapKodlari',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/StrHarcamaTakip/StrHesapKodlari/Index'),
  }, 
  {
    path: '/StrBirimHarcamaLimit',
    name: 'StrBirimHarcamaLimit',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/StrHarcamaTakip/StrBirimHarcamaLimit/Index'),
  }, 
  {
    path: '/StrBirimButceHarcamalari',
    name: 'StrBirimButceHarcamalari',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/StrHarcamaTakip/StrBirimButceHarcamalari/Index'),
  },
  {
    path: '/StrOdenekTalep',
    name: 'StrOdenekTalep',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/StrHarcamaTakip/StrOdenekTalep/Index'),
  },
  {
    path: '/GetBirimButce',
    name: 'GetBirimButce',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/StrHarcamaTakip/GetBirimButce/Index'),
  },
  {
    path: '/OKurumSabit',
    name: 'OKurumSabit',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/StrHarcamaTakip/OKurumSabit/Index'),
  },
  {
    path: '/StrBirimKontrolTutarlari',
    name: 'StrBirimKontrolTutarlari',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/StrHarcamaTakip/StrBirimKontrolTutarlari/Index'),
  },
  { 
    path: '/StrPlanDonemleri',
    name: 'StrPlanDonemleri',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/StrKurumsalPerformans/StrPerfDonem/Index'),
  },
  {
    path: '/StrStratejikAmaclar',
    name: 'StrStratejikAmaclar',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/StrKurumsalPerformans/StrStratejikAmac/Index'),
  },
  {
    path: '/StrHedefKartlari',
    name: 'StrHedefKartlari',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/StrKurumsalPerformans/StrHedefKartlari'),
  },
  {
    path: '/StrBirimGosterge',
    name: 'StrBirimGosterge',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/StrKurumsalPerformans/StrBirimGosterge'),
  },

  {
    path: '/StrDetayParametreTanimlari',
    name: 'StrDetayParametreTanimlari',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/StrKurumsalPerformans/StrPerfTablolarDetayParametreTanim/Index'),
  }, 
  {
    path: '/DetayParametreHedefTanimlari',
    name: 'DetayParametreHedefTanimlari',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/StrKurumsalPerformans/StrPerfTablolarDetayParametreHedefTanim/Index'),
  }, 
  {
    path: '/StrRenkAciklamalari',
    name: 'StrRenkAciklamalari',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/StrKurumsalPerformans/ORenkAciklamalari/Index'),
  },
  {
    path: '/StrGostergeGirisi',
    name: 'StrGostergeGirisi',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/StrKurumsalPerformans/StrGostergeGirisi'),
  },
  {
    path: '/GostergeTablolari',
    name: 'GostergeTablolari',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/StrKurumsalPerformans/GostergeTablolari'),
  },
  {
    path: '/StrPerformansRaporlari',
    name: 'StrPerformansRaporlari',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/StrKurumsalPerformans/StrPerformansRaporlari'),
  },
  {
    path: '/RiskRaporlari',
    name: 'RiskRaporlari',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/StrRaporlar/RiskRaporlari'),
  },
  {
    path: '/ProsesRaporlari',
    name: 'ProsesRaporlari',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/StrRaporlar/ProsesRaporlari'),
  },
  {
    path: '/StrStratejikPlanDegerlendirme',
    name: 'StrStratejikPlanDegerlendirme',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/StrKurumsalPerformans/StrPlanDeger/Index'),
  },
 
  {
    path: '/StrKontrolStandart',
    name: 'StrKontrolStandart',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/StrIcKontrolEylemPlani/StrKontrolStandart/Index'),
  },
  {
    path: '/StrKontrolEylem',
    name: 'StrKontrolEylem',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/StrIcKontrolEylemPlani/StrKontrolEylem/Index'),
  },
  {
    path: '/StrKontrolTanim',
    name: 'StrKontrolTanim',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/StrIcKontrolEylemPlani/StrKontrolTanim/Index'),
  },
  {
    path: '/StrKontrolIsbirlikci',
    name: 'StrKontrolIsbirlikci',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/StrIcKontrolEylemPlani/StrKontrolIsbirlikci/Index'),
  },
  {
    path: '/StrKontrolGiris',
    name: 'StrKontrolGiris',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/StrIcKontrolEylemPlani/StrKontrolGiris/Index'),
  },
  {
    path: '/StrIcDegerGiris',
    name: 'StrIcDegerGiris',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/StrKaliteOzDegerlendirme/StrIcDegerGiris/Index'),
  },
  {
    path: '/StrIcDegerTablo',
    name: 'StrIcDegerTablo',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/StrKaliteOzDegerlendirme/StrIcDegerTablo/Index'),
  },
  {
    path: '/StrRiskler',
    name: 'StrRiskler',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/StrRiskYonetimi/StrRiskler'),
  },

  {
    path: '/StrRisklerGirislerCevap',
    name: 'StrRisklerGirislerCevap',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/StrRiskYonetimi/StrRisklerGirislerCevap/Index'),
  },
  {
    path: '/StrRiskDeger',
    name: 'StrRiskDeger',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/StrRiskYonetimi/StrRiskDeger/Index'),
  },
  {
    path: '/StrRiskEylemPlani',
    name: 'StrRiskEylemPlani',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/StrRiskYonetimi/StrRiskEylemPlani/Index'),
  },
  {
    path: '/StrRiskDegerlendirmeKriterTablosu',
    name: 'StrRiskDegerlendirmeKriterTablosu',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/StrRiskYonetimi/StrRiskDegerlendirmeKriterTablosu/Index'),
  },

  {
    path: '/StrRaporBirimButceHarcamalari',
    name: 'StrRaporBirimButceHarcamalari',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/StrRaporlar/StrBirimButceHarcamalari/Index'),
  },
 
  {
    path: '/StrRaporIcDegerGiris',
    name: 'StrRaporIcDegerGiris',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/StrRaporlar/StrIcDegerGiris/Index'),
  },
  {
    path: '/StrIcKontrolRaporlar',
    name: 'StrIcKontrolRaporlar',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/StrRaporlar/IcKontrolRaporlar/Index'),
  },

  {
    path: '/StrProses',
    name: 'StrProses',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/StrProses/StrProses/Index'),
  },
  {
    path: '/StrBirimProses',
    name: 'StrBirimProses',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/StrProses/StrBirimProses/StrBirimProses'),
  },
  {
    path: '/StrProsesGiris',
    name: 'StrProsesGiris',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/StrProses/StrProsesGiris/Index'),
  },
   
  {
    path: '/ODuyuru',
    name: 'ODuyuru',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/ODuyuru/Index'),
  }, 
  {
    path: '/StrSorgular',
    name: 'StrSorgular',
    meta: { 
      authRequired: true,
    },
    component: () => import('./views/StrSorgular/index.vue'),
  },
 
  




  
   

 


  
  {
    path: '/login',
    name: 'login',
    component: () => import('./views/account/login'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'default' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('./views/account/register'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'default' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/forgot-password',
    name: 'Forgot password',
    component: () => import('./views/account/forgot-password'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'default' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  
  {
    path: '/logout',
    name: 'logout', 
    beforeEnter(to,from,next){  
    store.dispatch("auth/logOut") 
        next("/login") 
    },
     
  },
  {
    path: '/userroles',
    name: 'userroles', 
    component: () => import('./views/userroles/index'), 
     beforeEnter(to,from,next){  
          if(store.getters.["auth/isAuth"]){
          next() 
          }else{
            next("/login") 
          }
     }
  },
  {
    path: '/ouserbirimyetki',
    name: 'ouserbirimyetki', 
    component: () => import('./views/ouserbirimyetki/index'), 
     beforeEnter(to,from,next){  
          if(store.getters.["auth/isAuth"]){
          next()
          //window.location.href = "https://anket.giresun.edu.tr";
          }else{
            next("/login") 
          }
     }
  },
  {
    path: '/404',
    name: '404',
    component: require('./views/utility/404').default,
  }, 
  {
    path: '*',
    redirect: '404',
  },
  
]
